const wordRgx =
	/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð .'-]+$/u;
const wordNumbersRgx = /^[a-zA-Z0-9 '-]+$/u;
const numbersDashRgx = /^[0-9-]+$/u;

const checkMask = (position, mask, params) => {
	const m = mask[position];

	if (params.letters.length === 0 && params.deleting) return;
	if (params.finished) return;
	if (m === "%") {
		if (params.letters.length === 0) {
			params.finished = true;
			return;
		}
		params.checkNext = true;
	} else if (params.checkNext) {
		params.checkNext = false;
		const letter = params.letters.shift();

		if (m === "d" && letter !== " " && Number.isInteger(Number(letter))) {
			params.output = `${params.output}${letter}`;
		} else if (m === "s" && letter.match(wordRgx)) {
			params.output = `${params.output}${letter}`;
		} else if (m === "i" && letter.match(wordNumbersRgx)) {
			params.output = `${params.output}${letter}`;
		} else if (m === "n" && letter.match(numbersDashRgx)) {
			params.output = `${params.output}${letter}`;
		} else if (m === "a") {
			params.output = `${params.output}${letter}`;
		} else if (
			m === "D" &&
			letter !== " " &&
			Number.isInteger(Number(letter))
		) {
			if (params.previous.length > 0 && params.previous[0].type === "D") {
				if (
					+`${params.previous[0].value}${letter}` > 31 ||
					+`${params.previous[0].value}${letter}` < 1
				) {
					params.checkNext = true;

					if (params.letters.length > 0) {
						checkMask(position, mask, params);
					}
				} else {
					params.output = `${params.output}${letter}`;
				}
			} else {
				params.output = `${params.output}${letter}`;
			}
			params.previous.unshift({ type: m, value: letter });
		} else if (
			m === "M" &&
			letter !== " " &&
			Number.isInteger(Number(letter))
		) {
			if (params.previous.length > 0 && params.previous[0].type === "M") {
				if (
					+`${params.previous[0].value}${letter}` > 12 ||
					+`${params.previous[0].value}${letter}` < 1
				) {
					params.checkNext = true;

					if (params.letters.length > 0) {
						checkMask(position, mask, params);
					}
				} else {
					params.output = `${params.output}${letter}`;
				}
			} else {
				params.output = `${params.output}${letter}`;
			}
			params.previous.unshift({ type: m, value: letter });
		} else if (
			m === "Y" &&
			letter !== " " &&
			Number.isInteger(Number(letter))
		) {
			params.output = `${params.output}${letter}`;
			params.previous.unshift({ type: m, value: letter });
		} else {
			params.checkNext = true;

			if (params.letters.length > 0) {
				checkMask(position, mask, params);
			}
		}
	} else {
		if (m === params.letters[0]) {
			params.letters.shift();
		}
		params.output = `${params.output}${m}`;
	}
};

export const maskText = (mask, text, deleting = false) => {
	if (!text) {
		return text;
	}
	const params = {
		output: "",
		checkNext: false,
		finished: false,
		deleting,
		previous: [],
		letters: [...text],
	};

	for (let i = 0; i < mask.length; i += 1) {
		checkMask(i, mask, params);
	}

	return params.output;
};

export const removeSpaces = (text) => {
	if (!text) {
		return null;
	}

	return text.replace(/\s/g, "").trim();
};

export const CCLast4Digits = (number) => {
	if (!number) return number;
	const raw = removeSpaces(number);
	return raw.substring(raw.length - 4);
};

export const CCMasked = (number) => {
	if (!number) return number;
	return `•••• •••• •••• ${CCLast4Digits(number)}`;
};

export const IntToWord = (number) => {
	if (!number) return null;
	switch (number) {
		case 1:
			return "one";
		case 2:
			return "two";
		case 3:
			return "three";
		case 4:
			return "four";
		case 5:
			return "five";
		case 6:
			return "six";
		case 7:
			return "seven";
		case 8:
			return "eight";
		case 9:
			return "nine";
		default:
			return number;
	}
};

export const FormatMobile = (number) => {
	// Check if value is set
	if (!number) return number;

	// Check if only digits
	if (!/^\d+$/.test(number)) return number;

	let formatted = number.replace(/(\d)(?=(\d{3})+$)/g, "$1 ");
	const groups = formatted.split(" ");

	// Check if first group only has one digit and merge with second group
	// Eg. 0444564571 -> 0 444 564 571 -> 0444 564 571
	if (groups.length > 0 && groups[0].length === 1) {
		formatted = formatted.replace(" ", "");
	}

	return formatted;
};

export const MobileLast3Digits = (number) => {
	if (!number) return number;
	const raw = removeSpaces(number);
	return raw.substring(raw.length - 3);
};

export default {
	maskText,
	removeSpaces,
	CCMasked,
	CCLast4Digits,
	IntToWord,
	MobileLast3Digits,
	FormatMobile,
};
